import { ModelBase } from 'store/model-base';

import { ApiSource } from 'my-account/constants';

export class RequestStatus extends ModelBase {
    public static storeName: string = 'requestStatus';

    public requestId: Id;
    public status: string;
    public errorInfo: string;
    public source: ApiSource.XOM;

    // If API returns 201
    public scheduledDate: string;
    public monthlyCost: string;
}
